module.exports = __webpack_public_path__ + "static/media/studio-energy-logo.2e790292.png";